export default __webpack_public_path__ + "static/media/WordWork_05.870e88c2.png";